<template>
    <div class="remote-application-blocks">
        <div
            v-for="(block, index) in remoteApplication.blocks"
            :key="index"
            :class="`rounded mb-4 ${getBlockStatusColour(block)} lighten-5 pt-4`"
        >
            <v-layout class="px-4 mb-2" justify-space-between>
                <p :class="`text-h6 mb-0 ${getBlockStatusColour(block)}--text text--darken-1`">{{ block.label }}</p>
                <app-chip
                    :type="getBlockStatusColour(block)"
                    :prefix="$t('status')"
                    :text="$t(`enums.remote_application_block_status.${getBlockStatus(block)}`)"
                    bold
                />
            </v-layout>
            <div>
                <p class="remote-application-blocks__item px-4 py-1 mb-0">
                    {{ $t('amount') }}:
                    <display-money
                        class="font-weight-bold"
                        :value="{ currency: 'GBP', amount: block.amount }"
                        :options="{
                            decimals: 2,
                            abbreviate: false
                        }"
                        :fallback="$t('none')"
                    />
                    <app-copy-button :value="block.amount" />
                </p>
                <p class="remote-application-blocks__item px-4 py-1 mb-0">
                    {{ $t('investment_amount') }}:
                    <display-money
                        class="font-weight-bold"
                        :value="{ currency: 'GBP', amount: block.investment_amount }"
                        :options="{
                            decimals: 2,
                            abbreviate: false
                        }"
                        :fallback="$t('none')"
                    />
                    <app-copy-button :value="block.investment_amount" />
                </p>
                <p class="remote-application-blocks__item px-4 py-1 mb-0">
                    {{ $t('number_of_shares') }}:
                    <display-number class="font-weight-bold" :value="block.number_of_shares" fallback="-" />
                </p>
                <p class="remote-application-blocks__item px-4 py-1 mb-0">
                    {{ $t('allotment_at') }}:
                    <display-date class="font-weight-bold" :value="block.allotment_date" fallback="-" />
                </p>
                <p class="remote-application-blocks__item px-4 py-1 mb-0">
                    <span>{{ $t('funds_cleared_at') }}:</span>
                    <display-date class="font-weight-bold" :value="block.funds_cleared_at" fallback="-" />
                </p>
                <p class="remote-application-blocks__item px-4 py-1 pb-2 mb-0">
                    <span>{{ $t('funds_status') }}:</span>

                    <app-chip
                        :type="getBlockFundsStatusColour(block)"
                        :text="$t(`enums.remote_application_block_funds_status.${getBlockFundsStatus(block)}`)"
                        class="ml-2"
                    />
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { RemoteApplication } from '@/models';
import RemoteApplicationBlockStatusEnum from '@/enums/remoteApplication/blockStatus';
import RemoteApplicationBlockFundsStatusEnum from '@/enums/remoteApplication/blockFundsStatus';

export default {
    name: 'RemoteApplicationStatus',
    props: {
        remoteApplication: {
            type: RemoteApplication,
            required: true
        }
    },
    methods: {
        getBlockStatus(block) {
            return block.status || RemoteApplicationBlockStatusEnum.NONE;
        },
        getBlockStatusColour(block) {
            const status = this.getBlockStatus(block);

            if (status === RemoteApplicationBlockStatusEnum.RFA) {
                return 'warning';
            } else if (status === RemoteApplicationBlockStatusEnum.WITHDRAWN) {
                return 'warning';
            } else if (status === RemoteApplicationBlockStatusEnum.SUBMITTED) {
                return 'primary';
            } else if (status === RemoteApplicationBlockStatusEnum.ALLOTTED) {
                return 'success';
            }

            return 'primary';
        },
        getBlockFundsStatus(block) {
            return block.funds_status || RemoteApplicationBlockFundsStatusEnum.NONE;
        },
        getBlockFundsStatusColour(block) {
            const status = this.getBlockFundsStatus(block);

            if (status === RemoteApplicationBlockFundsStatusEnum.OUTSTANDING) {
                return 'warning';
            } else if (status === RemoteApplicationBlockFundsStatusEnum.CLEARED) {
                return 'success';
            } else if (status === RemoteApplicationBlockFundsStatusEnum.FULLY_CLEARED) {
                return 'success';
            }

            return 'primary';
        }
    }
};
</script>

<style lang="scss" scoped>
.remote-application-blocks {
    &__item:nth-child(odd) {
        background-color: rgba(0, 0, 0, 0.02);
    }
}
</style>
